import { ChangeDetectionStrategy, Component, Input, signal, WritableSignal } from '@angular/core';
import { NgClass } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ActionModalTemplate } from '@core';
import { HostRemovalReason } from '@core-http';
import { SingleRadioItemModel } from '@ui-components';

@Component({
  selector: 'lib-remove-player-reason',
  templateUrl: './remove-player-reason.component.html',
  styleUrls: ['./remove-player-reason.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, NgClass]
})
export class RemovePlayerReasonComponent implements ActionModalTemplate<HostRemovalReason> {
  @Input() reasons: SingleRadioItemModel<HostRemovalReason>[] = [];

  readonly selected: WritableSignal<HostRemovalReason | null> = signal<HostRemovalReason | null>(null);

  isSelected(value: HostRemovalReason): boolean {
    return this.selected() === value;
  }

  setData(event: CustomEvent): void {
    this.selected.set(event.detail.value);
  }
}
